import React, { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import "../../components/pdf/Fonts.js";

const TransportsHistoryPdf = ({
    currentStatus,
    transports,
}) => {
    // Inline styles
    const pdfStyles = {
        page: {
            flexDirection: 'column',
            backgroundColor: '#ffffff',
            padding: 30,
        },
        topColumn: {
            marginBottom: 5,
        },
        headers_container: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#000000',
            borderBottomStyle: 'solid',
            alignItems: 'center',
            paddingBottom: 5,
            paddingTop: 5,
        },
        headers: {
            fontFamily: 'Roboto',
            fontSize: 10,
            fontWeight: 'bold',
            flex: 1,
            textAlign: 'center',
        },
        bottomColumns: {
            marginBottom: 20,
        },
        cells_container: {
            flexDirection: 'row',
            borderBottomWidth: 1,
            borderBottomColor: '#D3D3D3',
            borderBottomStyle: 'solid',
            alignItems: 'center',
            paddingBottom: 5,
            paddingTop: 5,
        },
        cell: {
            fontFamily: 'Roboto',
            fontSize: 8,
            flex: 1,
            textAlign: 'center',
        }
    };

    return (
        <>
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' style={pdfStyles.page} wrap>
                        <View style={pdfStyles.topColumn} fixed>
                            <View style={pdfStyles.headers_container}>
                                <Text style={pdfStyles.headers}>{'Τωρινός Ιδιοκτήτης'}</Text>
                                <Text style={pdfStyles.headers}>{"Κωδικός στην εκτροφή"}</Text>
                                <Text style={pdfStyles.headers}>{"Κωδικός Γενεαλογικού Βιβλίου"}</Text>
                                <Text style={pdfStyles.headers}>{'Ημ/νια γέννησης'}</Text>
                            </View>
                        </View>
                        <View style={pdfStyles.bottomColumns}>
                            <View style={pdfStyles.cells_container} wrap={false}>
                                <Text style={pdfStyles.cell}>{currentStatus?.currentOwner}</Text>
                                <Text style={pdfStyles.cell}>{currentStatus?.flockCode}</Text>
                                <Text style={pdfStyles.cell}>{currentStatus?.registrationCode}</Text>
                                <Text style={pdfStyles.cell}>{currentStatus?.birthDate ? new Date(currentStatus?.birthDate).toLocaleDateString("el-GR") : ""}</Text>
                            </View>
                        </View>
                        <View style={pdfStyles.topColumn} fixed>
                            <View style={pdfStyles.headers_container}>
                                <Text style={pdfStyles.headers}>{'Προηγούμενος Ιδιοκτήτης'}</Text>
                                <Text style={pdfStyles.headers}>{'Ημερομηνία Μεταφοράς (από τον προηγ. ιδιοκτήτη)'}</Text>
                            </View>
                        </View>
                        <View style={pdfStyles.bottomColumns}>
                            {transports.map((item, index) =>
                                <View key={index} style={pdfStyles.cells_container} wrap={false}>
                                    <Text style={pdfStyles.cell}>{item?.oldOwner}</Text>
                                    <Text style={pdfStyles.cell}>{item?.transportDate ? new Date(item?.transportDate).toLocaleDateString("el-GR") : ""}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(TransportsHistoryPdf);